<template>
    <div class="card">
        <TreeTable :value="assessmentResultStore.getResultTemplates">
            <Column field="id" header="ID" :expander="true" />
            <Column field="name" header="NAME" />
            <Column field="type" header="TYPE" />

            <Column field="actions" header="ACTIONS">
                <template #body="slotProps">
                    <!-- <Button icon="pi pi-pencil" class="p-button-rounded p-button-success mr-2" @click="operateAttribute(slotProps.node?.data?.id, 'edit')" v-tooltip="'Edit Element'" /> -->
                    <Button icon="pi pi-trash" class="p-button-rounded p-button-danger mr-2" @click="operateAttribute(slotProps.node?.data?.id, 'delete')" v-tooltip="'Remove Element'" :disabled="slotProps.node?.children?.length > 0" />
                </template>
            </Column>
            <template #empty> No elements available. </template>
        </TreeTable>
    </div>
</template>

<script>
import { useAssessmentResultStore } from '@/store/assessment/assessmentResult';
import { useConfirm } from 'primevue/useconfirm';
import { useToast } from 'primevue/usetoast';
import useBoxBuilderComposable from '../../composables/BoxBuilderComposable';

export default {
    setup() {
        const confirm = useConfirm();
        const toast = useToast();
        const assessmentResultStore = useAssessmentResultStore();
        const { removeResultTemplate } = useBoxBuilderComposable();

        const operateAttribute = async (id, mode) => {
            if (mode == 'delete') {
                confirmDelete(id);
            }
        };

        const confirmDelete = (id) => {
            confirm.require({
                header: 'Confirmation',
                message: 'Are you sure you want to delete the element ' + id + '?',
                icon: 'pi pi-exclamation-triangle',
                accept: async () => {
                    await removeResultTemplate(id);
                },
                reject: () => {
                    toast.add({ severity: 'error', summary: 'Rejected', detail: 'Cancelled', life: 5000 });
                },
            });
        };

        return {
            assessmentResultStore,
            operateAttribute,
        };
    },
};
</script>
